import { observable } from "mobx";
import { outboxStoreData } from "Pages/Dashboard/outbox/outboxStore";
import React from "react";
import { userDetail } from "Stores/userDetail";
import { ReactComponent as AccountsIcon } from "./Icons/accounts.svg";
import { ReactComponent as CallsIcon } from "./Icons/calls.svg";
import { ReactComponent as ContactIcon } from "./Icons/contact.svg";
import { ReactComponent as DashboardIcon } from "./Icons/dashboard.svg";
import { ReactComponent as DiscoverIcon } from "./Icons/discover.svg";
import { ReactComponent as ReportsIcon } from "./Icons/reports.svg";
import { ReactComponent as SequenceIcon } from "./Icons/sequence.svg";
import { ReactComponent as TaskIcon } from "./Icons/task.svg";
import { ReactComponent as TemplateIcon } from "./Icons/template.svg";
import { ReactComponent as WebTrackingIcon } from "./Icons/webTracking.svg";

/**
 * @param {boolean} [listBuilderEnabled] - When true, show "List Builder" (path /list-builder); when false/undefined, show "Discover" (path /discover).
 */
export const getSideBarList = (listBuilderEnabled = false) => {
  const storedDisabledFeatures = userDetail?.featuresDisabled;
  const disabledFeatureSet = storedDisabledFeatures
    ? new Set(storedDisabledFeatures)
    : null;
  const sideBarItems = [
    {
      path: "/dashboard",
      name: "dashboardNew",
      title: "Dashboard",
      icon: <DashboardIcon />,
      featureTitle: "DASHBOARD"
    },
    {
      path: "/inbox",
      name: "inbox",
      title: "Inbox",
      icon: (
        <div className="inboxIconWrapper">
          <i className="material-icons-outlined inboxIcon">mail</i>
          {outboxStoreData?.unreadOutboxCount > 0 && (
            <span
              className={`count ${
                outboxStoreData?.unreadOutboxCount > 99
                  ? "moreDigits"
                  : outboxStoreData?.unreadOutboxCount > 9
                  ? "twoDigits"
                  : ""
              }`}
            >
              {outboxStoreData?.unreadOutboxCount > 99
                ? "99+"
                : outboxStoreData?.unreadOutboxCount}
            </span>
          )}
        </div>
      ),
      featureTitle: "INBOX"
    },
    {
      path: "/sequences",
      name: "sequences",
      title: "Sequences",
      icon: <SequenceIcon />,
      featureTitle: "SEQUENCES"
    },
    {
      path: "/templates",
      name: "templates",
      title: "Templates",
      icon: <TemplateIcon />,
      featureTitle: "TEMPLATES"
    },
    {
      path: "/contacts",
      name: "contacts",
      title: "Contacts",
      icon: <ContactIcon />,
      featureTitle: "CONTACTS"
    },
    {
      path: "/accounts",
      name: "accounts",
      title: "Accounts",
      icon: <AccountsIcon />,
      featureTitle: "ACCOUNTS"
    },
    {
      path: "/tasks",
      name: "tasks",
      title: "Tasks",
      icon: <TaskIcon />,
      featureTitle: "TASKS"
    },

    {
      path: "/calls",
      name: "calls",
      title: "Calls",
      icon: <CallsIcon />,
      featureTitle: "PHONE"
    },
    listBuilderEnabled === true
      ? {
          path: "/list-builder",
          name: "listBuilder",
          title: "List Builder",
          icon: <DiscoverIcon />,
          featureTitle: "DISCOVER"
        }
      : {
          path: "/discover",
          name: "discover",
          title: "Discover",
          icon: <DiscoverIcon />,
          featureTitle: "DISCOVER"
        },
    {
      path: "/website-tracking",
      name: "tracking",
      title: "Web Tracking",
      icon: <WebTrackingIcon />,
      featureTitle: "WEBSITE_TRACKING"
    },

    {
      path: "/reports",
      name: "reports",
      title: "Reports",
      icon: <ReportsIcon />,
      featureTitle: "REPORTS"
    }
  ];
  const filterSidBarItems = disabledFeatureSet
    ? sideBarItems.filter(item => !disabledFeatureSet.has(item.featureTitle))
    : sideBarItems;
  return observable(filterSidBarItems);
};
